// extracted by mini-css-extract-plugin
module.exports = {"paginationContainer":"paginationContainer--APZVj","grid":"grid--7id2r"};